import { useMemo, useState } from 'react'
import { useParams } from 'react-router'
import inboxApi from '@/state/inbox/inbox.slice'
import {
  type InboxContextTypes,
  initThread,
} from '@/state/entities/inbox/inbox.types'
import ThreadSendMessageBox from '../send/send-box'
import ThreadItemBox from '../thread'

export interface InboxContextProps {
  context_id: string
  context_type: InboxContextTypes
  serial?: string
  content?: string
}

function InboxContext({
  context_id,
  context_type,
  serial,
  content,
}: InboxContextProps) {
  const { org_id: orgId = '' } = useParams<{ org_id: string }>()
  const [sendType, setSendType] = useState<'messages' | 'notes'>('messages')

  const { data: contextThreads } = inboxApi.useGetInboxThreadsQuery({
    orgId,
    query: {
      context_id,
      context_type,
      serial,
    },
  })

  const selectedThread = useMemo(() => {
    if (!contextThreads)
      return {
        ...initThread,
        fake_thread: true,
      }
    return (
      contextThreads.data.find((i: any) => i.context_id === context_id) || {
        ...initThread,
        fake_thread: true,
      }
    )
  }, [contextThreads, context_id])

  if (!selectedThread.id) {
    return null
  }

  return (
    <div className="h-full relative overflow-visible flex flex-col bg-bg-default">
      {/* Scrollable Content Area */}
      <div
        className="
        flex-1
        overflow-y-auto
        p-4
        overscroll-contain
        snap-y
        snap-mandatory
      "
      >
        {selectedThread.id ? (
          <ThreadItemBox threadId={selectedThread.id} />
        ) : null}
      </div>

      {/* Fixed Send Message Box */}
      <div className="z-10">
        {selectedThread ? (
          <ThreadSendMessageBox
            onChangeSendType={setSendType}
            sendType={sendType}
            threadId={selectedThread.id}
            onComplete={() => {}}
            content={content}
          />
        ) : null}
      </div>
    </div>
  )
}

export default InboxContext
